import { useState } from 'react'
import useCooperationHooks from './hooks'
import { Row, Divider, Col, Modal, Space, Button, Form, Input } from 'antd'
import Style from '../return-order/return-order.module.scss'
import TableAntd from '../../components/TableAntd'
import Custompreviewimg from '../../components/PreviewUser'
const Cooperation = () => {
  const {
    visible,
    hideModal,
    infoObj,
    form,
    dataSource,
    isTableLoading,
    agreeReturnGoods,
    rejectReturnGoods,
    okModal,
  } = useCooperationHooks()

  const orderNoRender = (text: any, record: any, index: number) => {
    return index + 1 + ''
  }
  const listColumn = [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      render: orderNoRender,
    },
    {
      key: 'code',
      dataIndex: 'code',
      title: '商品编码',
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '商品名称',
    },
    {
      key: 'model',
      dataIndex: 'model',
      title: '型号',
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
    },
    {
      key: 'price',
      dataIndex: 'price',
      title: '单价',
    },
    {
      key: 'unCount',
      dataIndex: 'unCount',
      title: '取消数量',
    },
  ]
  const [previewimg, setPreviewimg] = useState<{
    data: string[] // 图片url
    currentIndex?: number // 开始索引
  }>({ data: [] })
  const itemLayou = {
    style: {
      marginBottom: '10px',
      marginLeft: '30px',
    },
  }
  return (
    <div style={{ padding: '0 20px' }}>
      <div className={Style.box}>
        <div className={Style.boxtitle}>
          <span>订单信息</span>
        </div>
        <Divider style={{ marginTop: 0 }} />
        <div style={{ padding: '0 20px' }}>
          <div className={Style.container}>
            <Row>
              <Col span={10}>
                <Row>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>客户订单号:</div>
                      <div className={Style['item-content']}>
                        {infoObj.orderNo}
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>订单状态:</div>
                      <div className={Style['item-content']}>
                        {infoObj.orderState}
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>下单时间:</div>
                      <div className={Style['item-content']}>
                        {infoObj.createTime}
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>发货进度:</div>
                      <div className={Style['item-content']}>
                        {infoObj.progress}
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>下单平台:</div>
                      <div className={Style['item-content']}>
                        {infoObj.platform}
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>下单金额:</div>
                      <div className={Style['item-content']}>
                        {infoObj.price}
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>退货金额:</div>
                      <div
                        className={Style['item-content']}
                        style={{
                          color: 'red',
                        }}
                      >
                        {infoObj.refundPrice}
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>最终结算金额:</div>
                      <div
                        className={Style['item-content']}
                        style={{
                          color: 'green',
                        }}
                      >
                        {infoObj.orderReturnState === '已退货' ||
                        infoObj.orderReturnState === '已取消' ||
                        infoObj.orderReturnState === '已拒绝'
                          ? infoObj.settlePrice
                          : '待订单完成后计算'}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col span={8}>
                <Row>
                  <Col span={24}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>客户开票:</div>
                      <div className={Style['item-content']}>
                        {infoObj.invoicingState}
                      </div>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>客户名称:</div>
                      <div className={Style['item-content']}>
                        {infoObj.customer}
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>联系方式:</div>
                      <div className={Style['item-content']}>
                        {infoObj.mobile}
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>收件人:</div>
                      <div className={Style['item-content']}>
                        {infoObj.consignee}
                      </div>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className={Style['item-container']}>
                      <div
                        className={Style['item-label']}
                        style={{ minWidth: '60px' }}
                      >
                        收件地址:
                      </div>
                      <div className={Style['item-content']}>
                        {infoObj.address}
                      </div>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>关联报备单:</div>
                      <div className={Style['item-content']}>
                        {infoObj.accountNo}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div className={Style.box}>
        <div className={Style.boxtitle}>
          <span>取消单信息</span>
        </div>
        <Divider style={{ marginTop: 0 }} />
        <div style={{ padding: '0 20px' }}>
          <div className={Style.container}>
            <Row>
              <Col span={10}>
                <div className={Style['item-container']}>
                  <div className={Style['item-label']}>状态:</div>
                  <div className={Style['item-content']}>
                    {infoObj.orderReturnState}
                    {infoObj.orderReturnState === '待审核' ||
                    infoObj.orderReturnState === '申请中' ? (
                      <Space style={{ marginLeft: '10px' }}>
                        <Button size="small" onClick={agreeReturnGoods}>
                          同意
                        </Button>
                        <Button size="small" onClick={rejectReturnGoods}>
                          拒绝
                        </Button>
                      </Space>
                    ) : null}
                  </div>
                </div>
                <div className={Style['item-container']}>
                  <div className={Style['item-label']}>取消单号:</div>
                  <div className={Style['item-content']}>
                    {infoObj.orderReturnNo}
                  </div>
                </div>
                <div className={Style['item-container']}>
                  <div className={Style['item-label']}>申请时间:</div>
                  <div className={Style['item-content']}>
                    {infoObj.applyTime}
                  </div>
                </div>
                <div className={Style['item-container']}>
                  <div className={Style['item-label']}>申请人:</div>
                  <div className={Style['item-content']}>
                    {infoObj.applyMan}
                  </div>
                </div>
              </Col>
              <Col span={14}>
                <Space direction="vertical">
                  <div className={Style.reason}>
                    <p>取消原因：</p>
                    <div>{infoObj.returnReason}</div>
                  </div>
                  <div className={Style.reason}>
                    <p>拒绝原因：</p>
                    <div>{infoObj.rejectReason}</div>
                  </div>
                </Space>
              </Col>
            </Row>
          </div>
        </div>
        <div style={{ padding: '0 20px' }}>
          <div className={Style.tableTitle}> 取消明细 </div>
          <TableAntd
            dataSource={dataSource}
            listColumn={listColumn}
            loading={isTableLoading}
            Y={560}
          ></TableAntd>
        </div>
      </div>
      <Modal
        title="提示"
        width={450}
        open={visible}
        onOk={okModal}
        onCancel={hideModal}
        okText="确定"
        cancelText="取消"
      >
        <Form form={form}>
          <Form.Item
            label="原因"
            name="reason"
            rules={[
              { required: true, whitespace: true, message: '请输入理由' },
            ]}
            {...itemLayou}
          >
            <Input.TextArea autoComplete="off" />
          </Form.Item>
        </Form>
      </Modal>
      <Custompreviewimg
        onClose={() =>
          setPreviewimg({
            data: [],
          })
        }
        images={previewimg}
      />
    </div>
  )
}

export default Cooperation
import { useState } from 'react'
import useCooperationHooks from './hooks'
import { Row, Divider, Col, Modal, Space, Button, Form, Input } from 'antd'
import Style from '../return-order/return-order.module.scss'
import TableAntd from '../../components/TableAntd'
import Custompreviewimg from '../../components/PreviewUser'
const Cooperation = () => {
  const {
    visible,
    hideModal,
    infoObj,
    form,
    dataSource,
    isTableLoading,
    agreeReturnGoods,
    rejectReturnGoods,
    okModal,
  } = useCooperationHooks()

  const orderNoRender = (text: any, record: any, index: number) => {
    return index + 1 + ''
  }
  const listColumn = [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      render: orderNoRender,
    },
    {
      key: 'code',
      dataIndex: 'code',
      title: '商品编码',
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '商品名称',
    },
    {
      key: 'model',
      dataIndex: 'model',
      title: '型号',
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
    },
    {
      key: 'price',
      dataIndex: 'price',
      title: '单价',
    },
    {
      key: 'unCount',
      dataIndex: 'unCount',
      title: '取消数量',
    },
  ]
  const [previewimg, setPreviewimg] = useState<{
    data: string[] // 图片url
    currentIndex?: number // 开始索引
  }>({ data: [] })
  const itemLayou = {
    style: {
      marginBottom: '10px',
      marginLeft: '30px',
    },
  }
  return (
    <div style={{ padding: '0 20px' }}>
      <div className={Style.box}>
        <div className={Style.boxtitle}>
          <span>订单信息</span>
        </div>
        <Divider style={{ marginTop: 0 }} />
        <div style={{ padding: '0 20px' }}>
          <div className={Style.container}>
            <Row>
              <Col span={10}>
                <Row>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>客户订单号:</div>
                      <div className={Style['item-content']}>
                        {infoObj.orderNo}
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>订单状态:</div>
                      <div className={Style['item-content']}>
                        {infoObj.orderState}
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>下单时间:</div>
                      <div className={Style['item-content']}>
                        {infoObj.createTime}
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>发货进度:</div>
                      <div className={Style['item-content']}>
                        {infoObj.progress}
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>下单平台:</div>
                      <div className={Style['item-content']}>
                        {infoObj.platform}
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>下单金额:</div>
                      <div className={Style['item-content']}>
                        {infoObj.price}
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>退货金额:</div>
                      <div
                        className={Style['item-content']}
                        style={{
                          color: 'red',
                        }}
                      >
                        {infoObj.refundPrice}
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>最终结算金额:</div>
                      <div
                        className={Style['item-content']}
                        style={{
                          color: 'green',
                        }}
                      >
                        {infoObj.orderReturnState === '已退货' ||
                        infoObj.orderReturnState === '已取消' ||
                        infoObj.orderReturnState === '已拒绝'
                          ? infoObj.settlePrice
                          : '待订单完成后计算'}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col span={8}>
                <Row>
                  <Col span={24}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>客户开票:</div>
                      <div className={Style['item-content']}>
                        {infoObj.invoicingState}
                      </div>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>客户名称:</div>
                      <div className={Style['item-content']}>
                        {infoObj.customer}
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>联系方式:</div>
                      <div className={Style['item-content']}>
                        {infoObj.mobile}
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>收件人:</div>
                      <div className={Style['item-content']}>
                        {infoObj.consignee}
                      </div>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className={Style['item-container']}>
                      <div
                        className={Style['item-label']}
                        style={{ minWidth: '60px' }}
                      >
                        收件地址:
                      </div>
                      <div className={Style['item-content']}>
                        {infoObj.address}
                      </div>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className={Style['item-container']}>
                      <div className={Style['item-label']}>关联报备单:</div>
                      <div className={Style['item-content']}>
                        {infoObj.accountNo}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div className={Style.box}>
        <div className={Style.boxtitle}>
          <span>取消单信息</span>
        </div>
        <Divider style={{ marginTop: 0 }} />
        <div style={{ padding: '0 20px' }}>
          <div className={Style.container}>
            <Row>
              <Col span={10}>
                <div className={Style['item-container']}>
                  <div className={Style['item-label']}>状态:</div>
                  <div className={Style['item-content']}>
                    {infoObj.orderReturnState}
                    {infoObj.orderReturnState === '待审核' ||
                    infoObj.orderReturnState === '申请中' ? (
                      <Space style={{ marginLeft: '10px' }}>
                        <Button size="small" onClick={agreeReturnGoods}>
                          同意
                        </Button>
                        <Button size="small" onClick={rejectReturnGoods}>
                          拒绝
                        </Button>
                      </Space>
                    ) : null}
                  </div>
                </div>
                <div className={Style['item-container']}>
                  <div className={Style['item-label']}>取消单号:</div>
                  <div className={Style['item-content']}>
                    {infoObj.orderReturnNo}
                  </div>
                </div>
                <div className={Style['item-container']}>
                  <div className={Style['item-label']}>申请时间:</div>
                  <div className={Style['item-content']}>
                    {infoObj.applyTime}
                  </div>
                </div>
                <div className={Style['item-container']}>
                  <div className={Style['item-label']}>申请人:</div>
                  <div className={Style['item-content']}>
                    {infoObj.applyMan}
                  </div>
                </div>
              </Col>
              <Col span={14}>
                <Space direction="vertical">
                  <div className={Style.reason}>
                    <p>取消原因：</p>
                    <div>{infoObj.returnReason}</div>
                  </div>
                  <div className={Style.reason}>
                    <p>拒绝原因：</p>
                    <div>{infoObj.rejectReason}</div>
                  </div>
                </Space>
              </Col>
            </Row>
          </div>
        </div>
        <div style={{ padding: '0 20px' }}>
          <div className={Style.tableTitle}> 取消明细 </div>
          <TableAntd
            dataSource={dataSource}
            listColumn={listColumn}
            loading={isTableLoading}
            Y={560}
          ></TableAntd>
        </div>
      </div>
      <Modal
        title="提示"
        width={450}
        open={visible}
        onOk={okModal}
        onCancel={hideModal}
        okText="确定"
        cancelText="取消"
      >
        <Form form={form}>
          <Form.Item
            label="原因"
            name="reason"
            rules={[
              { required: true, whitespace: true, message: '请输入理由' },
            ]}
            {...itemLayou}
          >
            <Input.TextArea autoComplete="off" />
          </Form.Item>
        </Form>
      </Modal>
      <Custompreviewimg
        onClose={() =>
          setPreviewimg({
            data: [],
          })
        }
        images={previewimg}
      />
    </div>
  )
}

export default Cooperation
